import { CalendarFilled, CloseCircleFilled } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Radio,
  Space,
  Switch,
  TimePicker,
} from "antd";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import React, { Fragment, useCallback, useState } from "react";
import "dayjs/locale/th";
import locale from "antd/es/date-picker/locale/th_TH";
import { THAI_DAY } from "utils/constants";
import api from "api";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.locale("th");

export default function CreateLeaveSetup({
  bookings,
  tfDate,
  setTfDate,
  golfCourseStartTime,
  golfCourseEndTime,
  isHolliday,
  setIsHolliday,
  setEndTime,
  endTime,
  startTime,
  setStartTime,
  setIsLoading,
  setIsCreate,
  userData,
  messageApi,
  setEditId,
  editId,
  formRef,
  getRestList,
  specificDisabledDates,
  selectStatus,
  setLeaveDateSelect,
  leaveDateSelect,
  isSpecific,
  setIsSpecific,
}) {
  const [isLeaveDateError, setIsLeaveDateError] = useState(false);

  const disableDates = (current) => {
    const isBeforeToday = current && current < new Date().setHours(0, 0, 0, 0); // ปิดการใช้งานวันก่อนหน้า
    const isSpecificDate = specificDisabledDates.some(
      (date) => current && current.format("YYYY-MM-DD") === date
    ); // ปิดการใช้งานวันเฉพาะ

    return isBeforeToday || isSpecificDate; // รวมเงื่อนไข
  };

  function onFinishErrorHandle() {
    if (!isSpecific && leaveDateSelect.length === 0) {
      setIsLeaveDateError(true);
      return;
    } else setIsLeaveDateError(false);
  }

  async function handleSubmitLeaveSetup(values) {
    if (!isSpecific && leaveDateSelect.length === 0) {
      setIsLeaveDateError(true);
      return;
    } else setIsLeaveDateError(false);

    setIsLoading(true);
    const date = dayjs(values.date).format("YYYY-MM-DD");
    const start_time = `${date} ${dayjs(values.start_time).format(
      "HH:mm:00.000"
    )}`;
    const end_time = `${date} ${dayjs(values.end_time).format("HH:mm:00.000")}`;

    let recurring_days = leaveDateSelect
      .sort((a, b) => a - b)
      .map((day) => THAI_DAY[day].prefix_day_name_en);

    const params = {
      date: date,
      start_time: !values.is_holiday ? start_time : null,
      end_time: !values.is_holiday ? end_time : null,
      is_active: true,
      is_holiday: values.is_holiday,
      user_id: userData.user_id,
      is_specific: isSpecific,
      recurring_days: recurring_days.length > 0 ? recurring_days : null,
    };

    if (editId) {
      try {
        const { status } = await api.caddyApi.updateLeaveSetup(
          editId,
          params,
          false
        );
        if (status === 200) {
          setIsCreate(false);
          messageApi.open({
            type: "success",
            content: "บันทึกข้อมูลสำเร็จแล้ว.",
          });

          setIsCreate(false);
          setEditId(null);
          setEndTime(null);
          setStartTime(null);
          setTfDate(null);
          setIsHolliday(false);
          setIsSpecific(false);
          setLeaveDateSelect([]);
          setIsLeaveDateError(false);

          formRef.current.resetFields();

          getRestList();
          setIsLoading(false);
        }
      } catch (error) {
        messageApi.open({
          type: "error",
          content: "บันทึกข้อมูลไม่สำเร็จ : " + error.message,
        });
        setIsLoading(false);
      }
    } else {
      try {
        const { status } = await api.caddyApi.createLeaveSetup(params, false);
        if (status === 201) {
          setIsCreate(false);
          messageApi.open({
            type: "success",
            content: "บันทึกข้อมูลสำเร็จแล้ว.",
          });

          setIsCreate(false);
          setEditId(null);
          setEndTime(null);
          setStartTime(null);
          setTfDate(null);
          setIsHolliday(false);
          setIsSpecific(false);
          setLeaveDateSelect([]);
          setIsLeaveDateError(false);

          formRef.current.resetFields();

          getRestList();
          setIsLoading(false);
        }
      } catch (error) {
        messageApi.open({
          type: "error",
          content: "บันทึกข้อมูลไม่สำเร็จ : " + error.message,
        });
        setIsLoading(false);
      }
    }
  }

  const disableTimesEnd = () => {
    const filter_booking =
      bookings && bookings.length > 0
        ? bookings.filter(
            (booking) => dayjs(booking.tf_date).format("YYYY-MM-DD") === tfDate
          )
        : [];

    const disabledHours = () => {
      let disable_list = [];

      Array.from({ length: 24 }, (_, i) => i).filter((hour) => {
        if (
          hour < parseInt(startTime) ||
          hour > parseInt(golfCourseEndTime.format("H")) ||
          hour < parseInt(golfCourseStartTime.format("H"))
        ) {
          disable_list.push(hour);
        } else {
          return filter_booking?.forEach((booking, index) => {
            const book_start = parseInt(
              dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                .add(7, "hours")
                .format("HH")
            );
            const book_end =
              parseInt(
                dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                  .add(13, "hours")
                  .format("HH")
              ) === 0
                ? 24
                : parseInt(
                    dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                      .add(13, "hours")
                      .format("HH")
                  );

            if (hour > book_start && hour < book_end) {
              disable_list.push(hour);
            } else if (
              filter_booking.length === index + 1 &&
              hour === book_start
            ) {
              disable_list.push(hour);
            }
          });
        }
      });
      return disable_list;
    };

    return {
      disabledHours,
    };
  };

  const disableTimesStart = () => {
    const filter_booking =
      bookings && bookings.length > 0
        ? bookings.filter(
            (booking) => dayjs(booking.tf_date).format("YYYY-MM-DD") === tfDate
          )
        : [];

    const disabledHours = () => {
      let disable_list = [];

      Array.from({ length: 24 }, (_, i) => i).filter((hour) => {
        if (
          hour > parseInt(endTime) ||
          hour < parseInt(golfCourseStartTime.format("H")) ||
          hour > parseInt(golfCourseEndTime.format("H"))
        ) {
          disable_list.push(hour);
        } else {
          return filter_booking?.forEach((booking, index) => {
            const book_start = parseInt(
              dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                .add(7, "hours")
                .format("HH")
            );
            const book_end =
              parseInt(
                dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                  .add(13, "hours")
                  .format("HH")
              ) === 0
                ? 24
                : parseInt(
                    dayjs(booking.tf_time, "YYYY-MM-DD HH:mm")
                      .add(13, "hours")
                      .format("HH")
                  );

            if (hour > book_start && hour < book_end) {
              disable_list.push(hour);
            } else if (
              filter_booking.length === index + 1 &&
              hour === book_start
            ) {
              disable_list.push(hour);
            }
          });
        }
      });
      return disable_list;
    };

    return {
      disabledHours,
    };
  };

  const disableMinutes = useCallback(
    (selectedHour) => {
      const minutes = [];

      if (selectedHour === parseInt(dayjs(startTime, "HH:mm").format("HH"))) {
        for (let i = 0; i < 60; i++) {
          if (i < dayjs(startTime, "HH:mm").format("mm")) {
            minutes.push(i);
          }
        }
      }

      if (!golfCourseEndTime) {
        for (let i = 0; i < 60; i++) {
          if (i !== parseInt(dayjs(startTime, "HH:mm").format("mm"))) {
            minutes.push(i);
          }
        }
      } else {
        if (
          selectedHour ===
          parseInt(dayjs(golfCourseEndTime, "HH:mm").format("HH"))
        ) {
          for (let i = 0; i < 60; i++) {
            if (i > dayjs(golfCourseEndTime, "HH:mm").format("mm")) {
              minutes.push(i);
            }
          }
        }
      }

      return minutes;
    },
    [startTime, golfCourseEndTime]
  );

  const disableHours = useCallback(() => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      if (
        i < dayjs(startTime, "HH:mm").format("HH") ||
        (!golfCourseEndTime && i > dayjs(startTime, "HH:mm").format("HH")) ||
        i > dayjs(golfCourseEndTime, "HH:mm").format("HH")
      ) {
        hours.push(i);
      }
    }
    return hours;
  }, [startTime, golfCourseEndTime]);

  function onClickSelectDate(value) {
    let select_date = [...leaveDateSelect];

    const find_existing = select_date.findIndex((date) => date === value);

    if (find_existing === -1) {
      select_date.push(value);
    } else {
      select_date.splice(find_existing, 1);
    }

    setLeaveDateSelect(select_date);

    if (select_date.length === 0) setIsLeaveDateError(true);
    else setIsLeaveDateError(false);
  }

  return (
    <div className="create-leave-setup-container">
      <div className="create-leave-setup-content">
        <div
          style={{
            position: "absolute",
            right: 10,
            top: 10,
            cursor: "pointer",
          }}
          onClick={() => {
            setIsCreate(false);
            setEditId(null);
            setEndTime(null);
            setStartTime(null);
            setTfDate(null);
            setIsHolliday(false);
            setLeaveDateSelect([]);
            setIsSpecific(false);

            formRef.current.resetFields();
          }}
        >
          <CloseCircleFilled style={{ fontSize: 30, color: "red" }} />
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            gap: 10,
            fontSize: 24,
            fontWeight: "bold",
            marginTop: 0,
          }}
        >
          <CalendarFilled />
          <div>เพิ่มวัน / เวลา ที่ไม่รับงาน</div>
        </div>
        <Divider />
        <Form
          ref={formRef}
          onFinishFailed={onFinishErrorHandle}
          onFinish={handleSubmitLeaveSetup}
        >
          <Form.Item
            style={{ marginTop: -15, width: "100%" }}
            initialValue={false}
            name="is_holiday"
            label={
              <div style={{ marginBottom: -10, fontSize: 16 }}>
                เวลาไม่รับงาน
              </div>
            }
            rules={[{ required: "true", message: "กรุณากรอก `เวลาไม่รับงาน`" }]}
          >
            <Radio.Group
              disabled={
                userData.register_state !== 2 ||
                (selectStatus === "ประวัติวันหยุด" && editId)
                  ? true
                  : false
              }
              onChange={(e) => setIsHolliday(e.target.value)}
              style={{ marginTop: -15, width: "100%" }}
            >
              <Space>
                <Radio value={false}>เลือกเวลา</Radio>
                <Radio value={true}>หยุดทั้งวัน</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          {!isSpecific && (
            <div
              style={{
                fontSize: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
                width: "100%",
                marginTop: -15,
              }}
            >
              {THAI_DAY.map((day, index) => {
                let isSelected =
                  leaveDateSelect.findIndex((date) => date === day.value) > -1;
                return (
                  <div
                    onClick={() => onClickSelectDate(day.value)}
                    style={{
                      cursor: "pointer",
                      color: isSelected
                        ? "#90c7c5"
                        : index === 0
                        ? "red"
                        : "black",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 40,
                      width: 40,
                      border: isSelected ? "1px solid #90c7c5" : "",
                      borderRadius: "50%",
                    }}
                  >
                    {day.prefix_day_name}
                  </div>
                );
              })}
            </div>
          )}

          {isLeaveDateError && !isSpecific && (
            <div style={{ color: "#ff4d4f" }}>กรุณาเลือก `วันหยุด`</div>
          )}

          {/* {!isHolliday && ( */}
          <Form.Item
            style={{ marginTop: isSpecific ? -35 : -10, width: "100%" }}
            initialValue={isSpecific}
            name="is_specific"
            label={
              <div style={{ marginBottom: -10, fontSize: 16, marginTop: 15 }}>
                เลือกเฉพาะวัน
              </div>
            }
          >
            <Switch
              value={isSpecific}
              onChange={(e) => {
                setIsSpecific(e);
                setLeaveDateSelect([]);
                setIsLeaveDateError(false);
              }}
            />
          </Form.Item>
          {/* )} */}

          {(isHolliday && isSpecific) || (!isHolliday && isSpecific) ? (
            <Form.Item
              style={{ marginTop: -15, width: "100%" }}
              name="date"
              label={
                <div style={{ marginBottom: -10, fontSize: 16 }}>วันที่พัก</div>
              }
              rules={[{ required: "true", message: "กรุณากรอก `วันที่พัก`" }]}
            >
              <DatePicker
                locale={locale}
                placeholder="เลือกวัน"
                disabled={
                  userData.register_state !== 2 ||
                  (selectStatus === "ประวัติวันหยุด" && editId)
                    ? true
                    : false
                }
                onChange={(e) => setTfDate(dayjs(e).format("YYYY-MM-DD"))}
                disabledDate={disableDates}
                format={(value) => `${dayjs(value).format("DD MMMM YYYY")}`}
                style={{ width: "100%", height: 40 }}
                inputReadOnly={true}
              />
            </Form.Item>
          ) : (
            <></>
          )}
          {!isHolliday && (
            <Fragment>
              <div style={{ marginTop: 15, fontSize: 18, fontWeight: "bold" }}>
                กำหนดเวลาไม่รับงาน
              </div>
              <div style={{ width: "100%", display: "flex", gap: 10 }}>
                <Form.Item
                  style={{ width: "100%" }}
                  name="start_time"
                  label={
                    <div style={{ marginBottom: -10, fontSize: 16 }}>
                      เวลาเริ่มต้น
                    </div>
                  }
                  rules={[
                    { required: "true", message: "กรุณากรอก `เวลาไม่รับงาน`" },
                  ]}
                >
                  <TimePicker
                    placeholder="เลือกเวลา"
                    // disabledTime={() => ({
                    //   disabledHours: disableTimesStart,
                    // })}
                    disabledTime={disableTimesStart}
                    onChange={(e) => setStartTime(dayjs(e).format("HH:mm"))}
                    format={"HH.mm"}
                    style={{ width: "100%", height: 40 }}
                    disabled={
                      (!tfDate && isSpecific) ||
                      userData.register_state !== 2 ||
                      (selectStatus === "ประวัติวันหยุด" && editId)
                        ? true
                        : false
                    }
                  />
                </Form.Item>
                <Form.Item
                  style={{ width: "100%" }}
                  name="end_time"
                  label={
                    <div style={{ marginBottom: -10, fontSize: 16 }}>
                      เวลาสิ้นสุด
                    </div>
                  }
                  rules={[
                    { required: "true", message: "กรุณากรอก `เวลาไม่รับงาน`" },
                  ]}
                >
                  <TimePicker
                    placeholder="เลือกเวลา"
                    // disabledTime={disableTimesEnd}
                    disabledTime={() => ({
                      disabledHours: disableHours,
                      disabledMinutes: disableMinutes,
                    })}
                    onChange={(e) => setEndTime(dayjs(e).format("HH:mm"))}
                    disabled={
                      !startTime ||
                      startTime === "Invalid Date" ||
                      (selectStatus === "ประวัติวันหยุด" && editId)
                        ? true
                        : userData.register_state !== 2
                        ? true
                        : false
                    }
                    format={"HH.mm"}
                    style={{ width: "100%", height: 40 }}
                  />
                </Form.Item>
              </div>
            </Fragment>
          )}
          <div style={{ color: "red", marginTop: -10 }}>
            {!isHolliday &&
              startTime &&
              startTime !== "Invalid Date" &&
              endTime &&
              endTime !== "Invalid Date" &&
              `เวลา ทีออฟ (Tee-Off) : ${
                dayjs(
                  `${dayjs().format("YYYY-MM-DD")} ${startTime}`,
                  "YYYY-MM-DD HH:mm"
                )
                  .subtract(6, "hours")
                  .isSameOrAfter(golfCourseStartTime)
                  ? dayjs(
                      `${dayjs().format("YYYY-MM-DD")} ${startTime}`,
                      "YYYY-MM-DD HH:mm"
                    )
                      .subtract(6, "hours")
                      .isSame(golfCourseStartTime)
                    ? `${dayjs(
                        `${dayjs().format("YYYY-MM-DD")} ${startTime}`,
                        "YYYY-MM-DD HH:mm"
                      )
                        .subtract(6, "hours")
                        .format("HH:mm")}`
                    : `ก่อน ${dayjs(
                        `${dayjs().format("YYYY-MM-DD")} ${startTime}`,
                        "YYYY-MM-DD HH:mm"
                      )
                        .subtract(6, "hours")
                        .format("HH:mm")}`
                  : ""
              } ${
                dayjs(`${dayjs().format("YYYY-MM-DD")} ${endTime}`).isBefore(
                  golfCourseEndTime
                )
                  ? parseInt(dayjs(endTime, "HH:mm").format("H")) ===
                    parseInt(golfCourseEndTime)
                    ? ""
                    : `หลัง ${dayjs(endTime, "HH:mm").format("HH:mm")}`
                  : ``
              } `}
          </div>

          <Form.Item style={{ alignSelf: "end", marginBottom: 0 }}>
            {(selectStatus === "ประวัติวันหยุด" && !editId) ||
            (selectStatus === "รายการวันหยุด" &&
              userData.register_state === 2) ? (
              <Button
                htmlType="submit"
                type="primary"
                style={{
                  width: "100%",
                  height: 50,
                  marginTop: 20,
                  backgroundColor: "#009951",
                  color: "white",
                  fontSize: 18,
                }}
              >
                <div>บันทึกข้อมูล</div>
              </Button>
            ) : (
              <></>
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
